import { css } from '@emotion/react'

const Styles = ({ colors }) => {
  const { scales: { grayShades, gray } } = colors
  return ({
    sectionContainer: css`
      padding: 1.175rem 0 3rem;
      display: flex;
      justify-content: space-between;
      max-width: 82rem;
      align-items: center; 
      flex-direction: column;
      background-color: ${grayShades[0]};
      margin: 0 auto;
      @media (max-width: 767px){
        padding: 0 1rem 2.5rem 1rem;
      }
    `,
    wrapper: css`
      text-align: 'center';
      margin-bottom: '.625rem';
    `,
    containerCards: css`
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      @media(max-width: 767px){
        justify-content: center;
      }
    `,
    hr: css`
      display: none;
      color: ${gray[2]};
      width: 10.25rem;
      @media (max-width: 767px){
        display: block;
      }
    `,
    title: css`
      text-align: center;
      @media (max-width: 767px) {
        padding-bottom: 1.5rem;
      }
    `
  })
}

export { Styles }
